import React, { useState } from 'react';
import { Link } from 'react-router-dom';

/* â”€â”€â”€ tiny icon helpers (inline SVG, zero deps) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const Icon = ({ d, size = 20, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
    className={className}>
    <path d={d} />
  </svg>
);

const ICONS = {
  wallet:   'M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2M3 10h18',
  chart:    'M18 20V10M12 20V4M6 20v-6',
  users:    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75M9 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8z',
  lock:     'M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2zM7 11V7a5 5 0 0 1 10 0v4',
  folder:   'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z',
  phone:    'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z',
  check:    'M20 6L9 17l-5-5',
  arrow:    'M5 12h14M12 5l7 7-7 7',
  shield:   'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  building: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 22V12h6v10',
  star:     'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z',
  layers:   'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
};

const features = [
  {
    icon: 'folder',
    title: 'Project-First Finance',
    desc: 'Every transaction is tied to a project. Switch projects from the top bar and the entire dashboard updates – balance, income, and expenses scoped exactly.',
  },
  {
    icon: 'wallet',
    title: 'Transaction Management',
    desc: 'Create, edit, filter, and export receipts & payments. Attach categories and persons. Full history with search and date-range filtering.',
  },
  {
    icon: 'users',
    title: 'Multi-Tenant Organizations',
    desc: 'Each organization is fully isolated. Invite members, assign roles, manage permissions. Perfect for agencies and teams running multiple clients.',
  },
  {
    icon: 'chart',
    title: 'Analytics & Reports',
    desc: 'Monthly trend charts, project-level summaries, and audit-safe history. Export data for external reporting.',
  },
  {
    icon: 'lock',
    title: 'Role-Based Access Control',
    desc: 'Organization Head, Admin, Finance Manager, Accountant, Project Manager, Employee, and Viewer – each with precisely scoped permissions.',
  },
  {
    icon: 'phone',
    title: 'Mobile API Ready',
    desc: 'REST APIs are fully documented and ready for the Android application. Project selection, transactions, history and org management – all API-backed.',
  },
];

const roles = [
  { name: 'Organization Head', note: 'Full control' },
  { name: 'Admin',             note: 'Operational control' },
  { name: 'Finance Manager',   note: 'Financial oversight' },
  { name: 'Accountant',        note: 'Transaction entry' },
  { name: 'Project Manager',   note: 'Project scope' },
  { name: 'Employee',          note: 'Assigned work' },
  { name: 'Viewer',            note: 'Read-only' },
];

const stats = [
  { value: '7',    label: 'User Roles' },
  { value: '100%', label: 'API Coverage' },
  { value: 'JWT',  label: 'Auth Standard' },
  { value: 'RBAC', label: 'Access Model' },
];

/* â”€â”€â”€ MAIN COMPONENT â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const ClientOverviewPage = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans">

      {/* â”€â”€ NAV â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-rose-600 text-white font-black text-lg flex items-center justify-center select-none">
              E
            </div>
            <div className="leading-none">
              <p className="text-sm font-black tracking-wide">EMS</p>
              <p className="text-[10px] text-slate-400">Expense Management</p>
            </div>
          </div>
          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-6 text-sm text-slate-600">
            <a href="#features" className="hover:text-slate-900 transition-colors">Features</a>
            <a href="#how"      className="hover:text-slate-900 transition-colors">How it works</a>
            <a href="#roles"    className="hover:text-slate-900 transition-colors">Roles</a>
            <a href="#mobile"   className="hover:text-slate-900 transition-colors">Mobile API</a>
          </div>
          {/* CTA */}
          <div className="flex items-center gap-2">
            <Link to="/login"
              className="hidden sm:inline-flex text-sm font-semibold px-4 py-2 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors">
              Sign In
            </Link>
            <Link to="/register"
              className="inline-flex text-sm font-semibold px-4 py-2 rounded-lg text-white bg-rose-600 hover:bg-rose-700 transition-colors">
              Get Started
            </Link>
            {/* Hamburger */}
            <button onClick={() => setMobileOpen(o => !o)}
              className="md:hidden ml-1 p-2 rounded-lg hover:bg-slate-100 transition-colors"
              aria-label="Menu">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {mobileOpen
                  ? <path d="M18 6L6 18M6 6l12 12"/>
                  : <path d="M3 12h18M3 6h18M3 18h18"/>}
              </svg>
            </button>
          </div>
        </div>
        {/* Mobile drawer */}
        {mobileOpen && (
          <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-1 text-sm">
            {[['#features','Features'],['#how','How it works'],['#roles','Roles'],['#mobile','Mobile API']].map(([href, label]) => (
              <a key={href} href={href} onClick={() => setMobileOpen(false)}
                className="block px-3 py-2 rounded-lg hover:bg-slate-50 text-slate-700">{label}</a>
            ))}
            <Link to="/login" onClick={() => setMobileOpen(false)}
              className="block px-3 py-2 rounded-lg hover:bg-slate-50 text-slate-700">Sign In</Link>
          </div>
        )}
      </nav>

      {/* â”€â”€ HERO â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-16 pb-20 text-center">
        <span className="inline-block text-xs font-bold tracking-widest uppercase text-rose-600 bg-rose-50 px-3 py-1.5 rounded-full mb-5">
          Project-Focused Finance Platform
        </span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight max-w-4xl mx-auto">
          Understand every project's money flow{' '}
          <span className="text-rose-600">in one clean system</span>
        </h1>
        <p className="mt-6 text-slate-500 text-lg max-w-2xl mx-auto leading-relaxed">
          EMS gives your team project-by-project financial visibility, role-based access, and
          a fully documented REST API ready for your Android application.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/login"
            className="inline-flex items-center gap-2 bg-rose-600 hover:bg-rose-700 text-white font-bold px-6 py-3 rounded-xl transition-colors text-sm">
            Open Dashboard
            <Icon d={ICONS.arrow} size={16} />
          </Link>
          <a href="#features"
            className="inline-flex items-center gap-2 border border-slate-200 hover:bg-slate-100 text-slate-700 font-bold px-6 py-3 rounded-xl transition-colors text-sm">
            See Features
          </a>
        </div>
        {/* Stats bar */}
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl mx-auto">
          {stats.map(({ value, label }) => (
            <div key={label} className="bg-white rounded-2xl border border-slate-200 py-4 px-2 shadow-sm">
              <p className="text-2xl font-black text-rose-600">{value}</p>
              <p className="text-xs text-slate-500 mt-0.5">{label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* â”€â”€ FEATURES â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section id="features" className="bg-white border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-black">Everything you need to run project finances</h2>
            <p className="mt-3 text-slate-500 max-w-xl mx-auto">
              Six core modules, built to work together from day one.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map(({ icon, title, desc }) => (
              <div key={title} className="rounded-2xl border border-slate-200 p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
                <div className="w-11 h-11 rounded-xl bg-rose-50 flex items-center justify-center mb-4">
                  <Icon d={ICONS[icon]} size={20} color="#e11d48" />
                </div>
                <h3 className="font-extrabold text-base mb-2">{title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* â”€â”€ HOW IT WORKS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section id="how" className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-black">How it works</h2>
          <p className="mt-3 text-slate-500">From login to full financial clarity in five steps.</p>
        </div>
        <div className="relative">
          {/* connector line */}
          <div className="hidden sm:block absolute left-[21px] top-8 bottom-8 w-0.5 bg-rose-100" />
          <div className="space-y-5">
            {[
              ['Log in', 'Authenticate with JWT-secured credentials and land in your workspace.'],
              ['Select a project', 'Pick the active project from the top bar â€” all data scopes immediately.'],
              ['View dashboard', 'See current balance, total income, and total expenses for that project.'],
              ['Manage transactions', 'Add, edit, filter and export income/expense entries with categories and persons.'],
              ['Review analytics', 'Monitor monthly trends, history, and audit logs across any date range.'],
            ].map(([step, detail], i) => (
              <div key={step} className="flex items-start gap-5 bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
                <div className="shrink-0 w-12 h-12 rounded-full bg-rose-600 text-white font-black text-lg flex items-center justify-center">
                  {i + 1}
                </div>
                <div>
                  <p className="font-extrabold text-base">{step}</p>
                  <p className="text-sm text-slate-500 mt-1">{detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* â”€â”€ ROLES â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section id="roles" className="bg-white border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
          <div className="lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
            <div>
              <h2 className="text-3xl font-black">Role-based access for every team size</h2>
              <p className="mt-4 text-slate-500 leading-relaxed">
                Seven distinct roles with granular, per-organization permissions. Restrict modules,
                override defaults, and audit every action. The permission system mirrors across the
                REST API so the Android app respects the same rules automatically.
              </p>
              <Link to="/register"
                className="inline-flex items-center gap-2 mt-6 bg-rose-600 hover:bg-rose-700 text-white font-bold px-5 py-2.5 rounded-xl transition-colors text-sm">
                Create your organization
                <Icon d={ICONS.arrow} size={15} />
              </Link>
            </div>
            <div className="mt-8 lg:mt-0 grid grid-cols-1 gap-2">
              {roles.map(({ name, note }, i) => (
                <div key={name} className="flex items-center justify-between rounded-xl border border-slate-200 px-4 py-3 bg-slate-50/60">
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 rounded-full bg-rose-100 text-rose-600 text-xs font-bold flex items-center justify-center">
                      {i + 1}
                    </div>
                    <span className="font-semibold text-sm">{name}</span>
                  </div>
                  <span className="text-xs text-slate-400 font-medium">{note}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* â”€â”€ MOBILE API â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section id="mobile" className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
        <div className="rounded-3xl bg-gradient-to-br from-rose-600 to-rose-800 text-white overflow-hidden">
          <div className="p-8 sm:p-12 lg:flex lg:items-center lg:gap-12">
            <div className="flex-1">
              <span className="inline-block text-xs font-bold tracking-widest uppercase text-rose-200 bg-white/10 px-3 py-1.5 rounded-full mb-4">
                Android App Ready
              </span>
              <h2 className="text-3xl font-black">Backend APIs are ready for mobile</h2>
              <p className="mt-4 text-rose-100 leading-relaxed">
                Every feature â€” project selection, financial summaries, transaction CRUD, history
                analytics, and organization permissions â€” is exposed via a documented REST API.
                Your Android app is one integration away.
              </p>
              <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
                {['Project API','Transactions','Analytics','Org & Roles'].map(api => (
                  <div key={api} className="bg-white/10 border border-white/20 rounded-xl px-3 py-2.5 text-center">
                    <Icon d={ICONS.check} size={14} className="mx-auto mb-1 text-rose-200" />
                    <p className="text-xs font-semibold">{api}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-8 lg:mt-0 lg:shrink-0 text-center">
              <div className="inline-block bg-white/10 border border-white/20 rounded-2xl p-6">
                <Icon d={ICONS.phone} size={48} color="white" />
                <p className="mt-3 text-2xl font-black">100%</p>
                <p className="text-sm text-rose-200">API Coverage</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* â”€â”€ CTA â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-16 text-center">
        <div className="bg-white border border-slate-200 rounded-3xl p-10 shadow-sm">
          <h2 className="text-3xl font-black">Ready to take control of your project finances?</h2>
          <p className="mt-4 text-slate-500 max-w-xl mx-auto">
            Create your organization, invite your team, and start tracking income and expenses
            project by project â€” in minutes.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link to="/register"
              className="inline-flex items-center gap-2 bg-rose-600 hover:bg-rose-700 text-white font-bold px-7 py-3 rounded-xl transition-colors">
              Get Started Free
              <Icon d={ICONS.arrow} size={16} />
            </Link>
            <Link to="/login"
              className="inline-flex items-center gap-2 border border-slate-200 hover:bg-slate-50 text-slate-700 font-bold px-7 py-3 rounded-xl transition-colors">
              Sign In
            </Link>
          </div>
        </div>
      </section>

      {/* ---- FOOTER ---- */}
      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md bg-rose-600 text-white text-xs font-black flex items-center justify-center">E</div>
            <span className="font-semibold text-slate-600">EMS</span>
            <span>by YMIT Solutions</span>
          </div>
          <div className="flex items-center gap-5">
            <Link to="/login"    className="hover:text-slate-600 transition-colors">Login</Link>
            <Link to="/register" className="hover:text-slate-600 transition-colors">Register</Link>
          </div>
          <p>Â© {new Date().getFullYear()} All rights reserved.</p>
        </div>
      </footer>

    </div>
  );
};

export default ClientOverviewPage;
